import { COLORS, FONTS } from '../../constants';

const styles = () => ({
  root: {
    fontFamily: FONTS.PRIMARY,
    fontSize: '0.75rem',
    textAlign: 'center',
    width: '100%',
    marginTop: 'auto',
    color: COLORS.GREY_DARK2,
    fontWeight: 400,
    lineHeight: '1.8',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
});

export default styles;
